<template>
    <div class="component__map">
        <iframe
            width="100%"
            height="100%"
            :src="`https://www.google.com/maps/embed/v1/place?key=${googleMapKey}&q=${googleMapQuery}`"
            frameborder="0"
        ></iframe>
    </div>
</template>

<script>
import api from '@/api'

export default {
  name: 'component-map',
  props: {
    address: {
      type: [Array, Object],
      default: () => {
      },
      required: true
    }
  },
  computed: {
    formattedAddress: function () {
      if (this.address.type === 'automatic') {
        return this.address.formatted_address
      } else {
        return `${this.address.address_1} ${this.address.address_2} ${this.address.city} ${this.address.postcode} ${this.address.county} ${this.address.country}`
      }
    },
    googleMapKey: function () {
      return api.googlekey
    },
    googleMapQuery: function () {
      return encodeURIComponent(this.formattedAddress)
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/shared/componentmap";
</style>
